import { DOCS_REQUEST, DOCS_SUCCESS, DOCS_FAILURE, DOCS_SELECT, DOCS_UPDATE } from "../actions/ite";
import {
  DOCS_RESET,
} from "../actions/docs";


const initialState = {
  docs: {
    state: "idle",
    selected: {},
    list: [],
    more: false,
  },
};

export default function ite(state = initialState, action) {
  switch (action.type) {
    case DOCS_REQUEST:
      return {
        ...state,
        docs: {
          ...state.docs,
          state: "loading"
        }
      };
    case DOCS_SUCCESS:
      return {
        ...state,
        docs: {
          ...state.docs,
          state: "success",
          list: [...action.payload.list],
          more: action.payload.more
        }
      };
    case DOCS_FAILURE:
      return {
        ...state,
        docs: {
          ...state.docs,
          state: "failure"
        }
      };
    case DOCS_SELECT:
      return {
        ...state,
        docs: {
          ...state.docs,
          selected: {
            ...state.docs.selected,
            ...action.payload
          }
        }
      };
      case DOCS_RESET:
        return {
          ...initialState,
        };
    case DOCS_UPDATE:
      return {
        ...state,
        docs: {
          ...state.docs,
          list: [...state.docs.list.map((el) => ({
            ...el, ...action.payload[el.id],
          }))],
        },
      };
    default:
      return state;
    }
}
